import { useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { EmailTab } from "../../../../../data/applications/LetterBox";
import { Href } from "../../../../../constants";
import SvgIcon from "../../../../../coreComponents/SvgIcon";

const EmailTabs = () => {
  const [navId,setNavId] = useState("pills-important-tab")

  return (
    <Nav id="email-content-tab">
      {EmailTab.map((data, i) => (
        <NavItem key={i}>
          <NavLink className={navId === data.id ? "active" : ""} id={data.id} href={Href} onClick={()=>setNavId(data.id)} >
            <SvgIcon className="stroke-icon" iconId={data.icon} />
            <span>{data.title} </span>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default EmailTabs;